const HomepageV8Logo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 64 64" fill="none">
      <g clipPath="url(#clip0_32013_1002)">
        <path
          d="M38.882 59.6582C37.8428 61.0172 38.5623 63.0156 40.2409 63.4153C41.6798 63.735 43.1187 63.8949 44.6375 63.8949C55.6688 63.9748 64.5419 54.782 63.9823 43.5908C63.5027 33.9984 55.8287 26.1645 46.3162 25.3651C44.2378 25.2053 42.1594 25.3651 40.2409 25.8448C38.5623 26.2444 37.8428 28.2429 38.882 29.6018C42.0795 33.7585 43.998 38.9545 43.998 44.63C43.998 50.3056 42.0795 55.5015 38.882 59.6582Z"
          fill="#FF6F5B"
        />
        <path
          d="M4.34949 38.8747C2.99056 37.8355 0.992127 38.5549 0.592441 40.2336C0.272692 41.6725 0.112818 43.1114 0.112818 44.6302C0.0328804 55.6615 9.3056 64.5346 20.4169 63.975C29.9294 63.4954 37.8432 55.8214 38.5627 46.2289C38.7225 44.1506 38.5626 42.0722 38.083 40.2336C37.6833 38.5549 35.6849 37.8355 34.326 38.8747C30.1692 42.0722 24.9733 43.9907 19.2978 43.9907C13.7022 43.9907 8.50623 42.0722 4.34949 38.8747Z"
          fill="#855AEA"
        />
        <path
          d="M0.0325285 18.2506C-0.60697 29.4419 8.26607 38.6346 19.2974 38.6346C20.8162 38.6346 22.2551 38.4748 23.694 38.155C25.3726 37.7553 26.172 35.7569 25.0529 34.398C21.8554 30.2412 19.9369 25.0453 19.9369 19.3698C19.9369 13.6942 21.8554 8.49829 25.0529 4.34155C26.0921 2.98262 25.3726 0.984185 23.694 0.584498C21.7755 0.104874 19.777 -0.0549997 17.6987 0.104875C8.26607 0.82431 0.592089 8.65816 0.0325285 18.2506Z"
          fill="#FF9900"
        />
        <path
          d="M59.6655 25.1254C61.0245 26.1646 63.0229 25.4451 63.4226 23.7665C63.7423 22.3276 63.9022 20.8887 63.9022 19.3699C63.9822 8.33857 54.7894 -0.534472 43.5982 0.0250889C34.0057 0.504713 26.1718 8.17869 25.3725 17.6912C25.2126 19.7696 25.3725 21.848 25.8521 23.7665C26.2518 25.4451 28.2502 26.1646 29.6091 25.1254C33.7659 21.9279 38.9618 20.0094 44.6373 20.0094C50.3129 20.0094 55.5088 21.9279 59.6655 25.1254Z"
          fill="#FF9CAE"
        />
      </g>
      <defs>
        <clipPath id="clip0_32013_1002">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HomepageV8Logo;
